'use client'

import React from 'react'
import { Paragraph } from '../../../atoms/Typography/Typography.component'

const BodyText = ({ text }) => {
  return (
    <Paragraph as="div">
      {text}
    </Paragraph>
  )
}

export default BodyText
